import React from "react";
import PropTypes from 'prop-types'
import TreeItem from "@material-ui/lab/TreeItem/TreeItem";
import ItemComponent from "./ItemComponent";
import AddNewItemButton from "./AddNewItemButton";

const TreeRender = (props) => {
    const {
        data, handleSelect, path = '', createNewItem,
        deleteItem, arrayPath, focusFirstPropertyField,
        onOpenContext
    } = props;

    const onKeyDown = (e, currentPath, arrayPath, index) => {
        e.stopPropagation();
        if (e.key === 'Enter') {
            handleSelect(e, currentPath);
            return
        }

        if (e.ctrlKey && e.shiftKey && e.key === 'Insert') {
            createNewItem(arrayPath, index);
            return
        }

        if (e.ctrlKey && e.key === 'Insert') {
            createNewItem(arrayPath, index + 1);
            return
        }

        if (e.ctrlKey && e.key === 'Delete') {
            deleteItem(currentPath)
        }
    };
    const onContextClick = (e, currentPath, arrayPath, index, inherited) => {
        e.stopPropagation();
        if (inherited) return;
        onOpenContext && onOpenContext(e, currentPath, arrayPath, index)
    };

    return (
        data.map((item, index) => {
            let currentPath = path + index;
            let hasChildren = item.type === 'entityEmbedded' || item.type === 'object';
            if (hasChildren) {
                const childrenProps = generateChildrenProps(item, currentPath);
                return (
                    <TreeItem
                        nodeId={currentPath} label={<ItemComponent item={item} disabled={item.inherit || !Boolean(onOpenContext)}/>} key={currentPath}
                        onKeyDown={e => onKeyDown(e, currentPath, arrayPath, index, item.inherit)}
                        onContextMenu={(e) => onContextClick(e, currentPath, arrayPath, index, item.inherit)}
                        onDoubleClick={focusFirstPropertyField}
                    >
                        {TreeRender({
                            data: childrenProps.schema,
                            handleSelect,
                            path: childrenProps.path,
                            createNewItem,
                            deleteItem,
                            arrayPath: childrenProps.arrayPath,
                            focusFirstPropertyField,
                            onOpenContext: item.type !== 'entityEmbedded' ? onOpenContext : null
                        })}

                        {item.type === 'object' && (!item.properties || !item.properties.length) && (
                            <AddNewItemButton
                                createNewItem={createNewItem}
                                index={index}
                                path={childrenProps.arrayPath}
                            />
                        )}
                    </TreeItem>
                )
            }

            return (
                <TreeItem
                    nodeId={currentPath}
                    label={<ItemComponent
                        item={item}
                        disabled={item.inherit || !Boolean(onOpenContext)}
                    />}
                    key={currentPath}
                    onKeyDown={e => onKeyDown(e, currentPath, arrayPath, index, item.inherit)}
                    onDoubleClick={focusFirstPropertyField}
                    onContextMenu={(e) => onContextClick(e, currentPath, arrayPath, index, item.inherit)}
                />
            )
        })
    )
};

export default TreeRender;

TreeRender.propTypes = {
    data: PropTypes.array,
    handleSelect: PropTypes.func,
    createNewItem: PropTypes.func,
    deleteItem: PropTypes.func,
    arrayPath: PropTypes.string, //recursive prop, using in create new item
    path: PropTypes.string, //recursive props, using in selecting item
    focusFirstPropertyField: PropTypes.func,
    onOpenContext: PropTypes.func
};

function generateChildrenProps(item, currentPath) {
    let childrenProps = {
        path: "",
        arrayPath: "",
        schema: ""
    };
    if (item.type === 'entityEmbedded') {
        childrenProps.path = `${currentPath}.schema.properties.`;
        childrenProps.arrayPath = `${currentPath}.schema.properties`;
        childrenProps.schema = item.schema ? item.schema.properties || [] : [];
        return childrenProps
    }

    childrenProps.path = `${currentPath}.properties.`;
    childrenProps.arrayPath = `${currentPath}.properties`;
    childrenProps.schema = item.properties ? item.properties || [] : [];
    return childrenProps
}